import { redirectToLogin } from "./annoucement-sheet";
import { api, language } from "./api";
import authHeader from "./auth-header";
import { getAuthUser } from "./dashboard";
export type DropdownDataWithLanguage = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
};
type DepartmentsResponse = {
  module_id: number;
  status: boolean;
  data: DepartmentInfo[];
  total: number;
};

export type TData = {
  data: DepartmentInfo[];
  total: number;
};
export type DepartmentInfo = {
  id?: number;
  name: string;
};
export type TaskDepartmentList = {
  dataList: TaskDepartmentListData[];
};
export type TaskDepartmentListData = {
  id: number;
  name_en: string;
  name_tc: string;
  name_sc: string;
  link_en: string;
  link_tc: string;
  link_sc: string;
};
export type IDepartPaginationData = {
  page: number;
  limit: number | string | undefined;
  search: string | number;
  sort?: string;
};
export const landingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMobileLandingPages: build.query<
      DepartmentsResponse,
      void
    >({
      query: () => {
        return ({
          url: `mobile-portal-links`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor: 0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    updateLandingData: build.mutation<TaskDepartmentList, DropdownDataWithLanguage>({
      query(body) {
        return {
          headers: authHeader(),
          url: `mobile-portal-links/${body.id}`,
          body,
          method: "PUT",
        };
      }
    }),
    getPortalData: build.query<
      any,
      void
    >({
      query: () => {
        return ({
          url: `mobile-portal-links/resources-center/sub-links`,
          headers: authHeader(),
        })
      },
      keepUnusedDataFor: 0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
    createPortalLink: build.mutation<TaskDepartmentList, any>({
      query(body) {
        const formData = new FormData();
        formData.append('name_en', body.name_en);
        formData.append('name_tc', body.name_tc);
        formData.append('name_sc', body.name_sc);
        formData.append('link_en', body.link_en);
        formData.append('link_tc', body.link_tc);
        formData.append('link_sc', body.link_sc);
        if (body.logo) {
          formData.append('file', body.logo);
        }
        var getUser = getAuthUser();
        return {
          headers: {
             Authorization: `Bearer ${getUser.token}`,
            "Content-Type": "multipart/formdata",
          },

          url: `mobile-portal-links`,
          body: formData,
          method: "POST"
        };
      }
    }),
    updatePortalLink: build.mutation<TaskDepartmentList, any>({
      query(body) {
        const formData = new FormData();
        formData.append('id', body.id);
        formData.append('name_en', body.name_en);
        formData.append('name_tc', body.name_tc);
        formData.append('name_sc', body.name_sc);
        formData.append('link_en', body.link_en);
        formData.append('link_tc', body.link_tc);
        formData.append('link_sc', body.link_sc);
        formData.append('file', body.logo);
        return {
          headers: authHeader(),
          url: `mobile-portal-links/${body.id}`,
          body,
          method: "PUT",
        };
      }
    }),
    deleteMobilePortalLink: build.mutation<any, number>({
          query:(id)=> {
            return {
              headers: authHeader(),
              url: `/mobile-portal-links/${id}`,
              method: "DELETE",
            };
          },
          // invalidatesTags: () => [{ type: 'Header' }],
        }),
  }),
});

export const {
  useGetMobileLandingPagesQuery,
  useUpdateLandingDataMutation,
  useCreatePortalLinkMutation,
  useUpdatePortalLinkMutation,
  useGetPortalDataQuery,
  useDeleteMobilePortalLinkMutation
} = landingApi;

export const {
  endpoints: {
    getMobileLandingPages,
    updateLandingData,
    getPortalData,
    createPortalLink,
    updatePortalLink
  },
} = landingApi;
